/**
 * App-Logger — eine Instanz des Framework-Loggers (pd-spa-helper `createLogger`,
 * darunter pd-utils): Kontext-Prefix, Level aus `VITE_LOG_LEVEL`, im DEV-Mode
 * alles. Kein eigener Console-Wrapper (Muster djkollektiv).
 */

import { createLogger } from "@progressive-development/pd-spa-helper";

export const logger = createLogger("PolitikApp");
